// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ScavengerHunt_pageWrapper__EPv1m","pageContainer":"ScavengerHunt_pageContainer__JqQXF"};